import React from 'react';
import { Button, Col, Row, Typography } from 'antd';
import buskwarehousedetail from '@modules/Busk/BuskWarehouseDetail/services/buskwarehousedetail';
import { useParams } from 'react-router';

interface IProps {
  totalReturns: number;
  selectedReturns: React.Key[];
}

const ReturnDisposalListHead = ({
  totalReturns,
  selectedReturns
}: IProps) => {
  const { id } = useParams<{ id: string }>();

  const handleExport = async () => {
    if (selectedReturns.length > 0) {
      const response =
        await buskwarehousedetail.exportReturn(
          id,
          selectedReturns
        );
      const outputFilename = `Return_disposal_240406T9g6QGJSxyR.xlsx`;

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response =
        await buskwarehousedetail.exportReturn(
          id
        );
      const outputFilename = `Return_disposal_240406T9g6QGJSxyR.xlsx`;

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  }

  return (
    <div className="busk-sellerSubHead">
      <Row align="middle">
        <Col flex="auto">
          <Row gutter={15}>
            <Col>
              <Typography.Text>총 반환/폐기 {totalReturns}</Typography.Text>
            </Col>
            <Col>|</Col>
            <Col>
              <Typography.Text>
                선택 반환/폐기 {selectedReturns.length}
              </Typography.Text>
            </Col>
          </Row>
        </Col>
        <Col>
          <Button
            style={{
              color: 'gray'
            }}
            onClick={() => handleExport()}
          >
            엑셀 다운로드
          </Button>
        </Col>
      </Row>
    </div>
  );
}

export default ReturnDisposalListHead;